<template>
  <div class="detail">
    <detail :mainTit="mainTit">
      <template v-slot:video>
        <iframe
          class="video"
          :src="video"
          frameborder="0"
          allowfullscreen
          v-if="video"
        ></iframe>
      </template>
      <template v-slot:tabs>
        <div class="H5summary" v-if="summary">
          <h5 style="color: #333333; margin: 10px auto">
            {{ $t("lang.Summary") }}
          </h5>
          <div>
            {{ summary }}
          </div>
        </div>
        <b-tabs pills nav-class="tabTitle">
          <b-tab :title="$t('lang.Speeches')" active>
            <div class="pt-5 tabContent" v-html="content.speech"></div>
          </b-tab>
          <b-tab :title="$t('lang.LecturerProfiles')">
            <div class="pt-5 tabContent" v-html="content.intro"></div>
          </b-tab>
        </b-tabs>
      </template>
      <template v-slot:right-related>
        <div class="row mt-5 summary" v-if="summary">
          <h5 style="color: #0092de; font-size: 1.2rem">
            {{ $t("lang.Summary") }}
          </h5>
          <div>
            {{ summary }}
          </div>
        </div>
        <detail-related
          :title="$t('lang.RelatedReading')"
          version="forum"
          :dataList="relatedList"
        ></detail-related>
      </template>
    </detail>
  </div>
</template>
<script>
import detail from "@/forumcomponents/detail.vue";
import detailRelated from "@/forumcomponents/detailRelated.vue";

export default {
  components: {
    detail,
    detailRelated,
  },
  data() {
    return {
      summary: "",
      video: "",
      mainTit: {
        topTxt: "AI伦理与治理系列 02期 · AI的公平性",
        lowTxt: "未来·局",
        date: "2021.05.23",
      },
      content: {
        speech:
          '<div class="tabContent active" data-value="1"><p><font size="2" color="#595959">数据要素已成为国家核心生产资本之一，安全释放数据资产价值是数字经济高质量可持续发展的关键动力。未来论坛“隐私安全计算”主题系列研讨会，从技术/商业/政策/公共服务四个维度深度探寻隐私计算技术及产业应用着力点，探讨其如何赋能政策监管和数据要素市场建设等行动举措，驱动数据红利发挥其积极的经济和社会效益。</font></p><p><font size="2" color="#595959"><br></font></p><p><font size="2" color="#595959">在数据政策红利的新业态下，系列研讨会已多视角解读数据政策与法规环境，多领域交流数据产业联盟和公共数据集可落地思路，本期起将专题聚焦解决数据流通的关键技术方案，结合前沿学术研究和产业实践应用，全面解析联邦学习、多方安全计算和差分隐私等隐私计算技术发展现状以及技术优化路径，以期促进隐私计算领域技术协同进步，加速服务数据流通和数据价值释放。</font></p><p><font size="2" color="#595959"><br></font></p><p><font color="#595959" size="2">分享嘉宾：</font></p><p><font color="#595959" size="2">- &nbsp; &nbsp;杨强，微众银行首席人工智能官、香港科技大学讲席教授</font></p><p><font color="#595959" size="2">- &nbsp; &nbsp;罗震，翼方健数(BaseBit.ai) CEO</font></p><p><br></p></div>',
        intro:
          '<div class="tabContent active" data-value="2"><p><br></p><p><font color="#595959" size="2">- &nbsp; &nbsp;杨强，微众银行首席人工智能官、香港科技大学讲席教授</font></p><p><font color="#595959" size="2">- &nbsp; &nbsp;罗震，翼方健数(BaseBit.ai) CEO</font></p><p><br></p></div>',
      },

      relatedList: [
        {
          title: "2020未来科学大奖举行云端颁奖典礼|科学之光 温暖世界",
          src: "http://www.futureprize.org/resource/data/uploads/13/2dfd9a8cc1aeb8737839d2d13a6ffe22.png",
          categoryId: "未来·局",
          date: "2012-5-26",
        },
        {
          title: "2020未来科学大奖举行云端颁奖",
          srcFileName:
            "http://www.futureprize.org/resource/data/uploads/13/2dfd9a8cc1aeb8737839d2d13a6ffe22.png",
          date: "2012-5-26",
        },
      ],
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.id = to.query.id;
        this.categoryId = to.query.categoryId;
        this.getProjectInfo();
        this.getAelateActivityList();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  methods: {
    getProjectInfo() {
      //活动详情
      this.$forumApi
        .projectInfo({
          id: this.id,
        })
        .then((res) => {
          // console.log('getProjectInfo----------', res);
          this.video = res.data.video;
          this.mainTit.topTxt = res.data.title;
          this.mainTit.lowTxt = res.data.categoryName;
          this.mainTit.date = res.data.createTime;
          this.content.speech = res.data.speech;
          this.content.intro = res.data.introduction;
          this.summary = res.data.summary;
        });
    },
    getAelateActivityList() {
      //相关活动
      this.$forumApi
        .relateActivityList({
          categoryId: this.categoryId,
          id: this.id,
        })
        .then((res) => {
          this.relatedList = res.data;
          console.log("getAelateActivityList----------", this.relatedList);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail::v-deep {
  .tabs {
    width: 100%;
    padding: 1rem 2rem 1rem 0rem;

    img {
      max-width: 100% !important;
    }
  }

  .summary {
    background-color: rgb(243, 242, 242);
    padding: 2rem;
    line-height: 1.8rem;
    color: #666666;
    flex: 1 1 0%;
    width: 30rem;
  }

  .video {
    width: 95%;
    height: 30rem;
  }

  .topTxt {
    color: #333333;
    font-size: 1.5rem;
    font-weight: 500;
    margin: 1rem 0rem 0.5rem 0rem;
  }

  .lowTxt {
    font-size: 0.9rem;
    color: #666666;
    width: 25rem;
  }
  .nav {
    .tabTitle {
      width: 10rem;
    }
    .nav-item {
      padding: 0rem;
      width: max-content;
      border: none;
      box-shadow: inset -1px 1px 1px 0px #ebebeb;
      border-bottom: 1px solid #ebebeb;
      a {
        border-radius: 0rem;
        padding: 0.7rem 2.5rem;
      }

      .tablelist {
        margin: 1rem 0rem 2rem 0rem;
      }
    }
  }
}
@media (min-width: 992px) {
  .detail::v-deep {
    .H5summary {
      display: none;
    }
    .lowTxt {
      font-size: 1rem !important;
    }
    .tabContent {
      min-height: 30rem;
    }
  }
}
@media (max-width: 768px) {
  .detail::v-deep {
    .topTxt {
      font-size: 1.3rem;
    }

    .video {
      width: 100%;
      height: 16rem;
      margin-top: 0rem;
      // transform: translateX(0px);
    }
    .summary {
      display: none;
    }
    .tabContent {
      min-height: 25rem;
    }
    .title {
      padding-bottom: 1rem;
      // border-bottom: 1px solid #ebebeb;
    }
    .H5summary {
      display: block;
      padding-bottom: 1rem;
      border-bottom: 1px solid #ebebeb;
      color: rgb(102, 102, 102);
    }
    .nav {
      .nav-item {
        a {
          padding: 0.7rem 1.1rem;
        }
      }
    }
  }
}
</style>